var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { of } from "rxjs";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { actionCoopAddSearchCoopMembers, actionCoopInfoReceived } from "../../cooperative/actionCoop";
import { actionNotYetImplemented } from "../../not-yet-implemented/actionNotYetImplemented";
export var networkNoticeCoopMemberInfoHandler = function (action$, state$, deps) { return function (res) {
    var state = state$.value;
    var newInfo = __assign({}, state.coopInfo, { member: res.member, coop: res.coop });
    if (res.coop && res.coop.id) {
        var ownId = selectPlayerInfo(state).coopId;
        if (res.coop.id.equals(ownId)) {
            return of(actionCoopInfoReceived(newInfo));
        }
        return of(actionCoopAddSearchCoopMembers(res.member));
    }
    return of(actionNotYetImplemented());
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeCoopMemberInfoHandler.ts
// module id = 2009
// module chunks = 3